import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import { sortDESC } from 'helpers'
import usersStore from 'Stores/usersStore'
import { translate as loc, dict } from 'Localisation'
import st from './EmployeeContracts.module.scss'
import EmployeeContract from './EmployeeContract'
import { BlockHeader } from 'components/UI/BlockHeader/BlockHeader'
import Button from 'components/CRM/UI/components/Button/Button'
import useWindowWidth from 'components/CRM/utils/hooks/useWindowWidth'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'

const EmployeeContracts = (props) => {
  const { setUserContracts, userContracts, setUserDocs } = usersStore
  const windowWidth = useWindowWidth()
  const addContract = () => {
    usersStore.createContract(loc, props.user)
  }

  const menu = [{ name: 'Add contact', action: 'add_contact' }]

  const action = (action) => {
    switch (action) {
      case 'add_contact':
        addContract()
        break
    }
  }

  useEffect(() => {
    if (!!props.user) {
      setUserContracts(props.user.profile.id)
      setUserDocs(props.user.profile.id)
    }
  }, [props.user, setUserContracts, setUserDocs])

  return (
    <div className={st.employeeContracts}>
      <BlockHeader title={props.translate.menu_contracts}>
        {windowWidth < 768 ? (
          <ActionMenu menu={menu} action={action} />
        ) : (
          <Button
            text={props.translate.add_contract}
            onClick={addContract}
            withIcon
            width={'170px'}
          ></Button>
        )}
      </BlockHeader>

      {userContracts.length ? (
        sortDESC(userContracts, 'id').map((contract) => (
          <EmployeeContract
            translate={props.translate}
            key={contract.id}
            contract={contract}
            user={props.user}
          />
        ))
      ) : (
        <span className={st.emptyContracts}>{loc(dict.contract.text_1)}</span>
      )}
      <footer className={st.footer} />
    </div>
  )
}

export default observer(EmployeeContracts)
